"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_DATA = exports.VISITOR_IDENTIFICATION_ATTRIBUTES = exports.TRACK_WIDGET_DRAGGED = exports.TRACK_API_USAGE = exports.SCROLL_PERCENTAGE_CHANGE = exports.REQUEST_OPEN = exports.REQUEST_CLOSE = exports.REFRESH_WIDGET_DATA = exports.PERF_ATTRIBUTES = exports.OPEN_TO_NEW_THREAD = exports.HUBSPOT_UTK = exports.GLOBAL_COOKIE_OPT_OUT = exports.FIRST_VISITOR_SESSION = exports.EXIT_INTENT = exports.BROWSER_WINDOW_RESIZE = exports.API_REQUEST_RESULT = void 0;
const WIDGET_DATA = exports.WIDGET_DATA = 'widget-data';
const HUBSPOT_UTK = exports.HUBSPOT_UTK = 'hubspot-utk';
const GLOBAL_COOKIE_OPT_OUT = exports.GLOBAL_COOKIE_OPT_OUT = 'global-cookie-opt-out';
const FIRST_VISITOR_SESSION = exports.FIRST_VISITOR_SESSION = 'first-visitor-session';
const REFRESH_WIDGET_DATA = exports.REFRESH_WIDGET_DATA = 'refresh-widget-data';
const REQUEST_OPEN = exports.REQUEST_OPEN = 'request-open';
const REQUEST_CLOSE = exports.REQUEST_CLOSE = 'request-close';
const BROWSER_WINDOW_RESIZE = exports.BROWSER_WINDOW_RESIZE = 'browser-window-resize';
const SCROLL_PERCENTAGE_CHANGE = exports.SCROLL_PERCENTAGE_CHANGE = 'scroll-percentage-change';
const EXIT_INTENT = exports.EXIT_INTENT = 'exit-intent';
const PERF_ATTRIBUTES = exports.PERF_ATTRIBUTES = 'perf-attributes';
const TRACK_API_USAGE = exports.TRACK_API_USAGE = 'track-api-usage';
const TRACK_WIDGET_DRAGGED = exports.TRACK_WIDGET_DRAGGED = 'track-widget-dragged';
const OPEN_TO_NEW_THREAD = exports.OPEN_TO_NEW_THREAD = 'open-to-new-thread';
const API_REQUEST_RESULT = exports.API_REQUEST_RESULT = 'api-request-result';
const VISITOR_IDENTIFICATION_ATTRIBUTES = exports.VISITOR_IDENTIFICATION_ATTRIBUTES = 'visitor-identification-attributes';